/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Messages_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to delete or remove embeds from messages by other members." |
*
* @param {Leveling_Perm_Manage_Messages_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_messages_hint = /** @type {((inputs?: Leveling_Perm_Manage_Messages_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Messages_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам удалять сообщения других участников и убирать из них встроенный контент.")
	return /** @type {LocalizedString} */ ("Allows members to delete or remove embeds from messages by other members.")
});